import types from "../types/types";

//TODO: Fix default init objet for roles.
const init = {
    type: types.roles_list,
    roles: {
        accounts: [{
            id: -1,
        }]
    }
}

export const rolesReducer = ( state = init, action ) => { 
    
    switch (action.type) {
        case types.roles_list :            
            return {
                ...state,
                roles: action.roles,
            };
            
        default:             
            return state;
    }
}
